module.exports = __webpack_public_path__ + "img/om.1798270b.svg";